import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31fe699e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_submenu__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "page_submenu__title" }, "Direct naar", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "page_submenu__notification"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_page_section = _resolveComponent("page-section")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: "page_submenu",
    revealOnScroll: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            href: `#${item.id}`,
            class: "page_submenu__link",
            key: `pagelink-${item.id}`,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToSection && _ctx.scrollToSection(...args)))
          }, [
            _createVNode(_component_Icon, {
              class: "page_submenu__link_icon",
              type: "arrow-down"
            }),
            _createTextVNode(" " + _toDisplayString(item.title) + " ", 1),
            (item.label)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ]),
    _: 1
  }))
}